import { removeNamespace } from '@/utils/helpers'
import OrderService from '@/services/order.service'
import { DaysUntilInStockSoon, OrderStatusIdentifier, OrderTab, PaymentSummary, OrderSearchType, OrderSortBy } from '../../utils/enums/order-enums'
import moment from 'moment'
// import router from '../../router'
import { ChapterPermissions } from '../../utils/enums/security-enums'
import { AUTH_TYPES } from './auth'
import * as cloneDeep from 'lodash.clonedeep'
import userService from '../../services/user.service'

export const ORDERS_TYPES = {
  getters: {
    showOrderIntentResultDialog: 'orders/showOrderIntentResultDialog',
    isAnythingToPrint: 'orders/isAnythingToPrint',
    canEditOrder: 'orders/canEditOrder',
    canEditShipping: 'orders/canEditShipping',
    canEditBilling: 'orders/canEditBilling',
    canEditBatch: 'orders/canEditBatch',
    canRefreshOrder: 'orders/canRefreshOrder',
    canEditOrderItems: 'orders/canEditOrderItems',
    canCancelLineItem: 'orders/canCancelLineItem',
    canCancelOrder: 'orders/canCancelOrder',
    canReturnBatchItems: 'orders/canReturnBatchItems',
    canSplitBatch: 'orders/canSplitBatch',
    giftCardReturns: 'orders/giftCardReturns',
    totalRefundedToStripe: 'orders/totalRefundedToStripe',
    totalRedeemedByGiftCards: 'orders/totalRedeemedByGiftCards'
  },
  mutations: {
    SET_LOADING: 'orders/SET_LOADING',
    SET_PAGED_ORDERS: 'orders/SET_PAGED_ORDERS',
    SET_TOTAL_ORDERS_COUNT: 'orders/SET_TOTAL_ORDERS_COUNT',
    SET_ORDER_TABLE_OPTIONS: 'orders/SET_ORDER_TABLE_OPTIONS',
    SET_ORDER_SEARCH_OPTIONS: 'orders/SET_ORDER_SEARCH_OPTIONS',
    SET_ORDER: 'orders/SET_ORDER',
    SET_ORDER_PRINTS: 'orders/SET_ORDER_PRINTS',
    ADD_ORDER_PRINT: 'orders/ADD_ORDER_PRINT',
    SET_LOADING_DETAILS: 'orders/SET_LOADING_DETAILS',
    SET_CURRENT_TAB: 'orders/SET_CURRENT_TAB',
    SET_TAB_COUNT: 'orders/SET_TAB_COUNT',
    SET_PROCESSING: 'orders/SET_PROCESSING',
    SET_PREPARING_PRINT: 'orders/SET_PREPARING_PRINT',
    SET_PICK_LIST_ITEMS: 'orders/SET_PICK_LIST_ITEMS',
    SET_PACK_SLIPS: 'orders/SET_PACK_SLIPS',
    SET_PURCHASE_LIST_ITEMS: 'orders/SET_PURCHASE_LIST_ITEMS',
    SET_SHOW_ORDER_INTENT_RESULT_DIALOG: 'orders/SET_SHOW_ORDER_INTENT_RESULT_DIALOG',
    SET_ORDER_INTENT_RESULT_MESSAGE: 'orders/SET_ORDER_INTENT_RESULT_MESSAGE',
    SET_ALLOW_CANCEL_PRINT: 'orders/SET_ALLOW_CANCEL_PRINT',
    SET_IS_ORDER_INTENT_RESULT_SUCCESS: 'orders/SET_IS_ORDER_INTENT_RESULT_SUCCESS',
    CLEAR_OPEN_ORDER_INTENT_RESULT: 'orders/CLEAR_OPEN_ORDER_INTENT_RESULT',
    SET_SHIPPING_METHODS: 'orders/SET_SHIPPING_METHODS',
    SET_TENANT_FILTER: 'orders/SET_TENANT_FILTER',
    REMOVE_PRINT_BATCH: 'orders/REMOVE_PRINT_BATCH',
    SET_SEARCH_TYPE: 'products/SET_SEARCH_TYPE',
    SET_DATES: 'products/SET_DATES',
    SET_LOADING_ADDRESSES: 'orders/SET_LOADING_ADDRESSES',
    SET_USER_ADDRESSES: 'orders/SET_USER_ADDRESSES',
    SET_LOADING_PAYMENT_METHODS: 'orders/SET_LOADING_PAYMENT_METHODS',
    SET_USER_PAYMENT_METHODS: 'orders/SET_USER_PAYMENT_METHODS',
    SET_MODIFYING: 'order/SET_MODIFYING'
  },
  actions: {
    changeTab: 'orders/changeTab',
    fetchOrdersPaged: 'orders/fetchOrdersPaged',
    fetchCustomerOrdersPaged: 'orders/fetchCustomerOrdersPaged',
    fetchOrder: 'orders/fetchOrder',
    fetchAlertCount: 'orders/fetchAlertCount',
    fetchInStockSoonCount: 'orders/fetchInStockSoonCount',
    fetchOrderCountByTab: 'orders/fetchOrderCountByTab',
    fetchOrderPrints: 'orders/fetchOrderPrints',
    printAllAccepted: 'orders/printAllAccepted',
    printSelected: 'orders/printSelected',
    forcePrintSelected: 'orders/forcePrintSelected',
    printSingle: 'orders/printSingle',
    printSinglePackSlips: 'orders/printSinglePackSlips',
    printSinglePickPurchaseLists: 'orders/printSinglePickPurchaseLists',
    reprint: 'orders/reprint',
    closeOrderIntentResultDialog: 'orders/closeOrderIntentResultDialog',
    doPrint: 'orders/doPrint',
    markFulfilled: 'orders/markFulfilled',
    markBatchFulfilled: 'orders/markBatchFulfilled',
    markBatchPickedUp: 'orders/markBatchPickedUp',
    cancelOrder: 'orders/cancelOrder',
    cancelItem: 'orders/cancelItem',
    denyItemCancellation: 'orders/denyItemCancellation',
    denyOrderCancellation: 'orders/denyOrderCancellation',
    sendOrderConfirmationEmail: 'orders/sendOrderConfirmationEmail',
    sendOrderConfirmationGroupEmail: 'orders/sendOrderConfirmationGroupEmail',
    sendBatchReceiptEmail: 'orders/sendBatchReceiptEmail',
    sendSMSText: 'orders/sendSMSText',
    updateOrder: 'orders/updateOrder',
    retryPayment: 'orders/retryPayment',
    changeShippingFilters: 'orders/changeShippingFilters',
    changeTenantFilter: 'orders/changeTenantFilter',
    removePrintBatchFilter: 'orders/removePrintBatchFilter',
    processReturn: 'orders/processReturn',
    splitBatch: 'orders/splitBatch',
    modifyPaymentMethod: 'orders/modifyPaymentMethod',
    refreshPricing: 'orders/refreshPricing',
    changeSearchType: 'orders/changeSearchType',
    changeDates: 'orders/changeDates',
    fetchUserAddresses: 'orders/fetchUserAddresses',
    saveUserAddress: 'orders/saveUserAddress',
    fetchUserPaymentMethods: 'orders/fetchUserPaymentMethods',
    modifyOrder: 'orders/modifyOrder',
    modifyShipping: 'orders/modifyShipping',
    markAsShipped: 'orders/markAsShipped',
    addOrderNote: 'orders/addOrderNote',
    deleteOrderNote: 'orders/deleteOrderNote',
    removeOrderAlert: 'orders/removeOrderAlert',
    displayZipFileErrors: 'orders/displayZipFileErrors',
    pollForResult: 'orders/pollForResult',
    getOrderPDFs: 'orders/getOrderPDFs'
  }
}

const _types = removeNamespace('orders', ORDERS_TYPES)

export const OrderDocTypes = Object.freeze({
  PackSlip: 1,
  PickList: 2,
  PurchaseList: 3,
  PickAndPurchaseList: 4,
  All: 5
})

const tabs = [
  {
    type: OrderTab.All,
    params: {}
  },
  {
    type: OrderTab.New,
    params: {
      statuses: [OrderStatusIdentifier.Accepted]
    }
  },
  {
    type: OrderTab.NewStorePickup,
    params: {
      incomingPickup: true
    },
    color: 'accent'
  },
  {
    type: OrderTab.Processing,
    params: {
      statuses: [OrderStatusIdentifier.Processing]
    }
  },
  {
    type: OrderTab.InStockSoon,
    params: {
      statuses: [OrderStatusIdentifier.Accepted, OrderStatusIdentifier.Processing],
      anticipatedInStockDateEnd: moment().add(DaysUntilInStockSoon, 'days').toISOString()
    },
    count: null,
    color: 'accent'
  },
  {
    type: OrderTab.ReadyToShip,
    params: {
      batchStatuses: [OrderStatusIdentifier.ReadyToShip]
    }
  },
  {
    type: OrderTab.ReadyForPickup,
    params: {
      batchStatuses: [OrderStatusIdentifier.ReadyForPickup]
    }
  },
  {
    type: OrderTab.Complete,
    params: {
      statuses: [OrderStatusIdentifier.Complete]
    }
  },
  {
    type: OrderTab.Alerts,
    params: {
      hasAlerts: true,
      statuses: OrderStatusIdentifier.Alert
    },
    count: null,
    color: 'error'
  }
]
const defaultTableOptions = {
  page: 1,
  itemsPerPage: 10,
  orderBy: OrderSortBy.CreatedAt,
  orderDescending: true
}

const defaultSearchOptions = {
  keyword: '',
  shippingMethods: [],
  tenantFilter: null,
  searchType: OrderSearchType.OrderNumber,
  dates: [],
  printBatch: null
}

const state = () => ({
  loading: false,
  orderTabs: tabs,
  currentTab: 0,
  orderTableOptions: cloneDeep(defaultTableOptions),
  orderSearchOptions: cloneDeep(defaultSearchOptions),
  pagedOrders: [],
  totalOrdersCount: 0,
  loadingDetails: false,
  order: null,
  processing: false,
  packSlips: null,
  pickListItems: null,
  isPreparingPrint: false,
  purchaseListItems: null,
  orderIntentResultMessage: null,
  isOrderIntentResultSuccess: false,
  allowCancelPrint: false,
  orderPrints: [],
  loadingAddresses: false,
  userAddresses: null,
  loadingPaymentMethods: false,
  userPaymentMethods: [],
  modifying: false
})

const editableStatuses = [
  OrderStatusIdentifier.Accepted,
  OrderStatusIdentifier.Processing,
  OrderStatusIdentifier.Fulfilled,
  OrderStatusIdentifier.CancelRequested
]

const paymentProcessedStatuses = [
  OrderStatusIdentifier.ReadyToShip,
  OrderStatusIdentifier.ReadyForPickup,
  OrderStatusIdentifier.Complete
]

let zipFileTaskId = null

const getters = {
  [_types.getters.showOrderIntentResultDialog]: state => {
    return !!state.orderIntentResultMessage
  },
  [_types.getters.isAnythingToPrint]: state => {
    return (state.pickListItems && state.pickListItems.length > 0) ||
      (state.packSlips && state.packSlips.length > 0) ||
      (state.purchaseListItems && state.purchaseListItems.length > 0)
  },
  [_types.getters.canEditOrder]: (state, getters, rootState, rootGetters) => {
    return rootGetters[AUTH_TYPES.getters.hasPermission](ChapterPermissions.CanEditOrders) &&
      state.order &&
      editableStatuses.includes(state.order.orderStatusId)
  },
  [_types.getters.canEditOrderItems]: (state, getters) => {
    // if there's no authorizedPayment then we have no payment instrument to charge against, so let's not allow adding items to the order
    // the user may have paid for the order entirely with gift cards, so we don't want to allow adding additional items because we wouldnt have a credit card to cover the extra amount that is not covered by the gift cards
    return getters.canEditOrder && state.order.authorizedPayment && state.order.paymentSummary === PaymentSummary.Authorized
  },
  [_types.getters.canEditShipping]: (state, getters) => {
    return getters.canEditOrder && state.order.batches.find(x => editableStatuses.includes(x.orderStatusId))
  },
  [_types.getters.canEditBilling]: (state, getters) => {
    return getters.canEditOrder && state.order.batches.find(x => editableStatuses.includes(x.orderStatusId))
  },
  [_types.getters.canRefreshOrder]: (state, getters) => {
    return getters.canEditOrder && !!state.order.batches.find(x => !paymentProcessedStatuses.includes(x.orderStatusId))
  },
  [_types.getters.canEditBatch]: (state, getters) => (batch) => {
    return getters.canEditOrder && batch && editableStatuses.includes(batch.orderStatusId)
  },
  [_types.getters.canCancelLineItem]: (state, getters) => (batch, lineItem) => {
    return getters.canEditBatch(batch) && lineItem && editableStatuses.includes(lineItem.orderStatusId) && (lineItem.product.giftCards != null && lineItem.product.giftCards.length === 0)
  },
  [_types.getters.canCancelOrder]: (state, getters, rootState, rootGetters) => {
    return rootGetters[AUTH_TYPES.getters.hasPermission](ChapterPermissions.CanCancelOrders) &&
      state.order &&
      state.order.paymentSummary === PaymentSummary.Authorized
  },
  [_types.getters.canReturnBatchItems]: (state, getters, rootState, rootGetters) => (batch) => {
    return rootGetters[AUTH_TYPES.getters.hasPermission](ChapterPermissions.CanProcessOrderReturns) &&
    batch && paymentProcessedStatuses.includes(batch.orderStatusId)
  },
  [_types.getters.canSplitBatch]: (state, getters) => (batch) => {
    return getters.canEditOrder && batch && editableStatuses.includes(batch.orderStatusId)
  },
  [_types.getters.giftCardReturns]: (state) => (batch) => {
    return state.order.giftCardTransactions ? state.order.giftCardTransactions.filter(x => x.transactionTypeId === 4) : []
  },
  [_types.getters.totalRefundedToStripe]: (state, getters) => (batch) => {
    const totalRefunded = state.order.totalRefundedAmount || 0
    const totalGiftCardRefunded = getters.giftCardReturns().map(x => x.transactionAmount).reduce((a, b) => a + b, 0)
    const anyBatchDiscount = state.order.batches.map(x => x.batchDiscount).reduce((a, b) => a + b, 0)
    const totalRefundedToStripe = totalRefunded - totalGiftCardRefunded - anyBatchDiscount
    return parseFloat(totalRefundedToStripe.toFixed(2))
  },
  [_types.getters.totalRedeemedByGiftCards]: (state, getters) => {
    let giftCardTotalRedeemed = 0
    if (state.order.giftCardTransactions) {
      state.order.giftCardTransactions.forEach(t => {
        if (t.transactionTypeId === 4 || t.transactionTypeId === 2 /** Return type is 4 - Debit type is 2 */) {
          giftCardTotalRedeemed += t.transactionAmount
        }
      })
    }
    return giftCardTotalRedeemed
  }
}

const mutations = {
  [_types.mutations.SET_CURRENT_TAB] (state, tab) {
    state.currentTab = tab
  },
  [_types.mutations.SET_LOADING] (state, bool) {
    state.loading = bool
  },
  [_types.mutations.SET_PAGED_ORDERS] (state, pagedResult) {
    state.pagedOrders = pagedResult
  },
  [_types.mutations.SET_TOTAL_ORDERS_COUNT] (state, count) {
    state.totalOrdersCount = count
  },
  [_types.mutations.SET_ORDER_TABLE_OPTIONS] (state, options) {
    state.orderTableOptions = cloneDeep(options)
  },
  [_types.mutations.SET_ORDER_SEARCH_OPTIONS] (state, options) {
    state.orderSearchOptions = cloneDeep(options)
  },
  [_types.mutations.SET_SEARCH_TYPE] (state, type) {
    state.orderSearchOptions.searchType = type
  },
  [_types.mutations.SET_DATES] (state, newDates) {
    state.orderSearchOptions.dates = newDates
  },
  [_types.mutations.SET_LOADING_DETAILS] (state, loading) {
    state.loadingDetails = loading
  },
  [_types.mutations.SET_ORDER] (state, order) {
    // this is a fix for bug 21149
    // state.order = order.setOrder && order.setOrder === false ? state.order : order
    state.order = order

    /** useful for returns, calculating the total amount
     *  actually fulfilled to stripe for this order */
    let totalFulfilled = 0
    order.batches.forEach(batch => {
      batch.payments.forEach(p => {
        totalFulfilled += p.amount
      })
    })
    state.order.totalFulfilledToStripe = parseFloat(totalFulfilled.toFixed(2))

    let totalRefundedToGiftCards = 0
    order.giftCardTransactions.forEach(t => {
      if (t.transactionTypeId === 4 /** Return type is 4 */) {
        totalRefundedToGiftCards += t.transactionAmount
      }
    })

    let totalRefundedToStripe
    if (order.totalRefundedAmount > 0) {
      totalRefundedToStripe = order.totalRefundedAmount - totalRefundedToGiftCards
    } else {
      totalRefundedToStripe = order.totalRefundedAmount
    }
    state.order.totalRefundedToStripe = parseFloat(totalRefundedToStripe.toFixed(2))
  },
  [_types.mutations.SET_ORDER_PRINTS] (state, prints) {
    state.orderPrints = prints
  },
  [_types.mutations.ADD_ORDER_PRINT] (state, print) {
    state.orderPrints = [print, ...state.orderPrints]
  },
  [_types.mutations.SET_TAB_COUNT] (state, { count, tab }) {
    const orderTab = state.orderTabs.find(x => x.type === tab)
    orderTab.count = count
  },
  [_types.mutations.SET_PROCESSING] (state, processing) {
    state.processing = processing
  },
  [_types.mutations.SET_PREPARING_PRINT] (state, preparing) {
    state.isPreparingPrint = preparing
  },
  [_types.mutations.SET_PICK_LIST_ITEMS] (state, list) {
    state.pickListItems = list
  },
  [_types.mutations.SET_PACK_SLIPS] (state, packSlips) {
    state.packSlips = packSlips
  },
  [_types.mutations.SET_PURCHASE_LIST_ITEMS] (state, list) {
    state.purchaseListItems = list
  },
  [_types.mutations.SET_ORDER_INTENT_RESULT_MESSAGE] (state, message) {
    state.orderIntentResultMessage = message
  },
  [_types.mutations.SET_ALLOW_CANCEL_PRINT] (state, allow) {
    state.allowCancelPrint = allow
  },
  [_types.mutations.SET_IS_ORDER_INTENT_RESULT_SUCCESS] (state, isSuccess) {
    state.isOrderIntentResultSuccess = isSuccess
  },
  [_types.mutations.CLEAR_OPEN_ORDER_INTENT_RESULT] (state) {
    state.pickListItems = []
    state.packSlips = []
    state.purchaseListItems = []
  },
  [_types.mutations.SET_SHIPPING_METHODS] (state, value) {
    state.orderSearchOptions.shippingMethods = value
  },
  [_types.mutations.SET_TENANT_FILTER] (state, value) {
    state.orderSearchOptions.tenantFilter = value
  },
  [_types.mutations.SET_SHIPPING_FILTER] (state, value) {
    state.orderSearchOptions.shippingFilter = value
  },
  [_types.mutations.REMOVE_PRINT_BATCH] (state) {
    state.orderSearchOptions.printBatch = null
  },
  [_types.mutations.SET_LOADING_ADDRESSES] (state, bool) {
    state.loadingAddresses = bool
  },
  [_types.mutations.SET_USER_ADDRESSES] (state, addresses) {
    state.userAddresses = addresses
  },
  [_types.mutations.SET_LOADING_PAYMENT_METHODS] (state, bool) {
    state.loadingPaymentMethods = bool
  },
  [_types.mutations.SET_USER_PAYMENT_METHODS] (state, paymentMethods) {
    state.userPaymentMethods = paymentMethods
  },
  [_types.mutations.SET_MODIFYING] (state, bool) {
    state.modifying = bool
  }
}

const actions = {
  [_types.actions.retryPayment] ({ state, commit }, intent) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.processPayment(intent)
      .then((res) => {
        commit(_types.mutations.SET_ORDER, res)
      })
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.removeOrderAlert] ({ state, commit }, { order, id }) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.removeOrderAlert(order.id, id)
      .then((res) => {
        commit(_types.mutations.SET_ORDER, res)
      })
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.updateOrder] ({ state, commit }, order) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.updateOrder(order)
      .then((res) => {
        commit(_types.mutations.SET_ORDER, res)
      })
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.sendOrderConfirmationEmail] ({ state, commit }) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.sendOrderConfirmationEmail(state.order.id)
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.sendOrderConfirmationGroupEmail] ({ state, commit }, emailOptions) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.sendOrderConfirmationGroupEmail(state.order.id, emailOptions)
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.sendBatchReceiptEmail] ({ state, commit }, batchId) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.sendBatchReceiptEmail(state.order.id, batchId)
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.sendSMSText] ({ state, commit }) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.sendSMSText(state.order.id)
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.denyOrderCancellation] ({ state, commit }) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.updateOrderStatus(state.order.id, OrderStatusIdentifier.Accepted)
      .then((order) => {
        commit(_types.mutations.SET_ORDER, order)
      })
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.denyItemCancellation] ({ state, commit }, item) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.updateItemStatus(state.order.id, item.orderBatchId, item.id, OrderStatusIdentifier.Accepted)
      .then((order) => {
        commit(_types.mutations.SET_ORDER, order)
      })
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.cancelItem] ({ state, commit }, { item, emailRequired }) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.updateItemStatus(state.order.id, item.orderBatchId, item.id, OrderStatusIdentifier.Cancelled, emailRequired)
      .then((order) => {
        commit(_types.mutations.SET_ORDER, order)
      })
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.cancelOrder] ({ state, commit }, emailRequired) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.updateOrderStatus(state.order.id, OrderStatusIdentifier.Cancelled, emailRequired)
      .then((order) => {
        commit(_types.mutations.SET_ORDER, order)
      })
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.processReturn] ({ state, commit }, { orderId, batchId, returnItems, cardAmount, giftCardIntents }) {
    commit(_types.mutations.SET_PROCESSING, true)
    giftCardIntents = giftCardIntents.filter(x => x.giftCardAmount > 0)

    return OrderService.createOrderReturnIntents(orderId, batchId, returnItems, true, cardAmount, giftCardIntents)
      .then((intent) => {
        commit(_types.mutations.SET_ORDER, intent.result.order)
        return intent.result.order
      })
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.splitBatch] ({ state, commit }, { orderId, batchId, splitItems }) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.createSplitBatchIntents(orderId, batchId, splitItems)
      .then((intent) => {
        commit(_types.mutations.SET_ORDER, intent.result)
        return intent.result.order
      })
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.modifyPaymentMethod] ({ state, commit }, { orderId, paymentSourceToken, paymentMethod, billingAddress }) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.createModifyOrderPaymentIntents(orderId, paymentSourceToken, paymentMethod, billingAddress)
      .then((intent) => {
        commit(_types.mutations.SET_ORDER, intent.result.order)
        return intent.result.order
      })
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.refreshPricing] ({ state, commit }, { orderId, commitOrder }) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.createRefreshOrderPricingIntents(orderId, commitOrder)
      .then((intent) => {
        // to prevent NaN on total calculation for credit card in payment summary, we need to copy over these values
        intent.result.totalFulfilledToStripe = state.order.totalFulfilledToStripe
        intent.result.totalRefundedToStripe = state.order.totalRefundedToStripe
        if (commitOrder) {
          commit(_types.mutations.SET_ORDER, intent.result)
        }
        return intent
      })
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.closeOrderIntentResultDialog] ({ commit, dispatch }, shouldContinue) {
    commit(_types.mutations.SET_ORDER_INTENT_RESULT_MESSAGE, null)
    commit(_types.mutations.SET_IS_ORDER_INTENT_RESULT_SUCCESS, false)
    commit(_types.mutations.SET_ALLOW_CANCEL_PRINT, false)
    let taskId = zipFileTaskId
    if (shouldContinue && zipFileTaskId) {
      // dispatch(_types.actions.doPrint)
      zipFileTaskId = null
      dispatch(_types.actions.pollForResult, taskId)
    }
  },
  [_types.actions.printAllAccepted] ({ commit, dispatch }) {
    commit(_types.mutations.SET_PROCESSING, true)
    commit(_types.mutations.SET_PREPARING_PRINT, true)
    return OrderService.createOpenOrderIntents(null, false, [OrderStatusIdentifier.Accepted])
      .then((res) => {
        commit(_types.mutations.SET_PROCESSING, false)
        if (res.value.successCount === 0) {
          commit(_types.mutations.SET_ORDER_INTENT_RESULT_MESSAGE,
            'No orders could be printed; please fix any alerts, and print any orders past \'Accepted\' status individually.')
        } else if (res.value.failureCount > 0) {
          commit(_types.mutations.SET_ORDER_INTENT_RESULT_MESSAGE,
            `${res.value.successCount}/${res.value.failureCount + res.value.successCount} orders will be printed; for the remaining orders please fix any alerts, and print any past 'Accepted' status individually.`)
          dispatch(_types.actions.pollForResult, res.value.taskId)
        } else {
          dispatch(_types.actions.pollForResult, res.value.taskId)
        }
      })
      .finally(() => {
      })
  },
  [_types.actions.printSelected] ({ commit, dispatch }, selectedOrders) {
    commit(_types.mutations.SET_PROCESSING, true)
    commit(_types.mutations.SET_PREPARING_PRINT, true)
    return OrderService.createOpenOrderIntents(selectedOrders.map(x => x.id))
      .then((res) => {
        commit(_types.mutations.SET_PROCESSING, false)
        if (res.value.successCount === 0) {
          commit(_types.mutations.SET_PROCESSING, false)
          commit(_types.mutations.SET_PREPARING_PRINT, false)
          commit(_types.mutations.SET_ORDER_INTENT_RESULT_MESSAGE,
            'No orders could be printed; please fix any alerts, and print any orders past \'Accepted\' status individually.')
        } else if (res.value.failureCount > 0) {
          commit(_types.mutations.SET_PROCESSING, false)
          commit(_types.mutations.SET_PREPARING_PRINT, false)
          commit(_types.mutations.SET_ORDER_INTENT_RESULT_MESSAGE,
            `${res.value.successCount}/${res.value.failureCount + res.value.successCount} orders will be printed; for the remaining orders please fix any alerts, and print any past 'Accepted' status individually.`)
        } else {
          dispatch(_types.actions.pollForResult, res.value.taskId)
        }
      })
      .finally(() => {
      })
  },
  [_types.actions.forcePrintSelected] ({ commit, dispatch }, selectedOrders) {
    commit(_types.mutations.SET_PROCESSING, true)
    commit(_types.mutations.SET_PREPARING_PRINT, true)
    return OrderService.createOpenOrderIntents(selectedOrders.map(x => x.id), true)
      .then((res) => {
        if (res && (res.value.pickListCount > 0 ||
            res.value.packSlipCount > 0 ||
            res.value.purchaseListCount > 0)) {
          dispatch(_types.actions.pollForResult, res.value.taskId)
        } else {
          commit(_types.mutations.SET_PROCESSING, false)
          commit(_types.mutations.SET_PREPARING_PRINT, false)
          commit(_types.mutations.SET_ORDER_INTENT_RESULT_MESSAGE,
            'No orders could be printed; please fix any alerts, and print any orders past \'Accepted\' status individually.')
        }
      })
      .finally(() => {
      })
  },
  [_types.actions.printSingle] ({ commit, dispatch }, selectedOrder) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.createOpenOrderIntents([selectedOrder.id], true, [], OrderDocTypes.All)
      .then((res) => {
        commit(_types.mutations.SET_PROCESSING, false)
        if (res.value.successCount === 0) {
          commit(_types.mutations.SET_ORDER_INTENT_RESULT_MESSAGE,
            `Order could not be set to 'Processing' status - download the printout(s) anyway?`)
          commit(_types.mutations.SET_ALLOW_CANCEL_PRINT, true)
          zipFileTaskId = res.value.taskId
        } else {
          dispatch(_types.actions.pollForResult, res.value.taskId)
        }
      })
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.printSinglePackSlips] ({ commit, dispatch }, selectedOrder) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.createOpenOrderIntents([selectedOrder.id], true, [], OrderDocTypes.PackSlip)
      .then((res) => {
        commit(_types.mutations.SET_PROCESSING, false)
        if (res.value.successCount === 0) {
          commit(_types.mutations.SET_ORDER_INTENT_RESULT_MESSAGE,
            `Order could not be set to 'Processing' status - generate the printout anyway?`)
          commit(_types.mutations.SET_ALLOW_CANCEL_PRINT, true)
          zipFileTaskId = res.value.taskId
        } else {
          dispatch(_types.actions.pollForResult, res.value.taskId)
        }
      })
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.printSinglePickPurchaseLists] ({ commit, dispatch }, selectedOrder) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.createOpenOrderIntents([selectedOrder.id], true, [], OrderDocTypes.PickAndPurchaseList)
      .then((res) => {
        commit(_types.mutations.SET_PROCESSING, false)
        if (res.value.successCount === 0) {
          commit(_types.mutations.SET_ORDER_INTENT_RESULT_MESSAGE,
            `Order could not be set to 'Processing' status - generate the printout anyway?`)
          commit(_types.mutations.SET_ALLOW_CANCEL_PRINT, true)
          zipFileTaskId = res.value.taskId
        } else {
          dispatch(_types.actions.pollForResult, res.value.taskId)
        }
      })
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.reprint] ({ commit, dispatch }, orderPrintId) {
    commit(_types.mutations.SET_PROCESSING, true)
    commit(_types.mutations.SET_PREPARING_PRINT, true)
    return OrderService.getOrderPrint(orderPrintId)
      .then((taskId) => {
        dispatch(_types.actions.pollForResult, taskId)
      })
      .finally(() => {
      })
  },
  // send the zip to the user for download, they'll print from that
  [_types.actions.doPrint] ({ commit, getters }, file) {
    if (file) {
      const fileContent = Buffer.from(file.fileContents, 'base64')
      const blob = new Blob([fileContent], { type: 'application/zip' })

      // Create a URL for the blob and trigger the download
      const url = window.URL.createObjectURL(blob)
      const a = document.createElement('a')
      a.href = url
      a.download = file.fileDownloadName // Use the specified filename
      a.style.display = 'none'
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    } else {
      commit(_types.mutations.SET_ORDER_INTENT_RESULT_MESSAGE, 'An error occurred and the download file could not be created. <br/><br/>Please try again. If the problem persists please contact technical support')
    }
  },
  [_types.actions.pollForResult] ({ commit, dispatch }, taskId) {
    if (taskId) {
      commit(_types.mutations.SET_PROCESSING, true)
      commit(_types.mutations.SET_PREPARING_PRINT, true)
      return OrderService.getOrderPrintStatus(taskId)
        .then((res) => {
          console.log(res)
          if (res && res.value && res.value.isCompleted === true) {
            commit(_types.mutations.SET_PREPARING_PRINT, false)
            commit(_types.mutations.SET_PROCESSING, false)
            dispatch(_types.actions.displayZipFileErrors, res.value)
            dispatch(_types.actions.doPrint, res.value.file)
          } else {
            setTimeout(() => {
              commit(_types.mutations.SET_PROCESSING, true)
              commit(_types.mutations.SET_PREPARING_PRINT, true)
              dispatch(_types.actions.pollForResult, taskId)
            }, 15000)
          }
        }).finally(() => {
        })
    } else {
      commit(_types.mutations.SET_PREPARING_PRINT, false)
      commit(_types.mutations.SET_PROCESSING, false)
    }
  },
  [_types.actions.getOrderPDFs] ({ commit, dispatch }) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.getOrderPrintStatuses()
      .then((res) => {
        console.log(res)
        commit(_types.mutations.SET_PROCESSING, false)
        return res
      }).finally(() => {
        commit(_types.mutations.SET_PROCESSING, false)
      })
  },
  [_types.actions.markFulfilled] ({ commit, dispatch }, selectedOrders) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.createFulfillOrderIntents(selectedOrders.map(x => x.id))
      .then((res) => {
        commit(_types.mutations.SET_PROCESSING, false)
        let message
        if (res.alertCount === 0 && res.failureCount === 0) {
          commit(_types.mutations.SET_IS_ORDER_INTENT_RESULT_SUCCESS, true)
          message = (selectedOrders.length === 1 ? 'Your order was' : 'All orders were') + ' marked as fulfilled!'
        } else if (res.alertCount === 0 && res.successCount === 0) {
          if (selectedOrders.length === 1) {
            message = `Your order could not be marked as fulfilled. Check that it is in 'Processing' status, or if it has more than one shipment mark each as fulfilled individually`
          } else {
            message = `No orders could be marked as fulfilled. Check that they are in 'Processing' status, and mark any orders with multiple shipments individually.`
          }
        } else {
          message = `${res.successCount}/${res.failureCount + res.successCount} orders were marked as fulfilled. Check that the failed orders are in 'Processing' status, and mark any orders with multiple shipments individually.`
          if (res.alertCount === 1) {
            message += ' There is 1 alert; go to the alert tab to continue processing that order.'
          } else if (res.alertCount > 1) {
            message += `There are ${res.alertCount} alerts; go to the alert tab to continue processing those orders.`
          }
        }
        commit(_types.mutations.SET_ORDER_INTENT_RESULT_MESSAGE, message)
        dispatch(_types.actions.fetchOrdersPaged)
        dispatch(_types.actions.fetchAlertCount)
      })
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.markBatchFulfilled] ({ commit, dispatch }, { batch, bypassPayment }) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.updateBatchStatus(batch.orderId, batch.id, OrderStatusIdentifier.Fulfilled, false, bypassPayment)
      .then((order) => {
        commit(_types.mutations.SET_ORDER, order)
      })
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.markBatchPickedUp] ({ commit, dispatch }, batch) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.updateBatchStatus(batch.orderId, batch.id, OrderStatusIdentifier.Complete)
      .then((order) => {
        commit(_types.mutations.SET_ORDER, order)
      })
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.changeTab] ({ commit, dispatch }, tab) {
    commit(_types.mutations.SET_CURRENT_TAB, tab)
    commit(_types.mutations.SET_PAGED_ORDERS, [])
    commit(_types.mutations.SET_TOTAL_ORDERS_COUNT, 0)
    commit(_types.mutations.SET_ORDER_TABLE_OPTIONS, defaultTableOptions)
    commit(_types.mutations.SET_ORDER_SEARCH_OPTIONS, defaultSearchOptions)
    // resetting orderSearchOptions triggers fetchOrdersPaged via watch in index.vue
  },
  [_types.actions.fetchAlertCount] ({ dispatch }) {
    dispatch(_types.actions.fetchOrderCountByTab, OrderTab.Alerts)
  },
  [_types.actions.fetchInStockSoonCount] ({ dispatch }) {
    dispatch(_types.actions.fetchOrderCountByTab, OrderTab.InStockSoon)
  },
  [_types.actions.fetchOrderCountByTab] ({ commit, state }, tab) {
    const params = {
      ...state.orderTabs[tab].params,
      skipCount: 0,
      maxResultCount: 0
    }
    return OrderService.getAll(params)
      .then((res) => {
        commit(_types.mutations.SET_TAB_COUNT, { count: res.totalCount, tab: tab })
      })
  },
  [_types.actions.fetchOrdersPaged] ({ state, commit }) {
    commit(_types.mutations.SET_LOADING, true)
    const { itemsPerPage, page, orderBy, orderDescending } = state.orderTableOptions
    const { keyword, searchType, dates } = state.orderSearchOptions
    const params = {
      ...state.orderTabs[state.currentTab].params,
      keyword,
      searchType,
      shippingFilter: state.orderSearchOptions.shippingMethods,
      tenantFilter: state.orderSearchOptions.tenantFilter,
      // statuses: state.currentTab === OrderTab.Alerts ? [1, 2, 3, 4, 5, 6, 7] : [1, 2, 3, 4, 5, 6, 7, 8],
      skipCount: (page - 1) * itemsPerPage,
      maxResultCount: itemsPerPage,
      orderBy,
      orderDescending,
      startDate: dates[0],
      endDate: dates[1],
      orderIds: state.orderSearchOptions.printBatch != null && state.orderSearchOptions.printBatch.printOrderIds.length ? state.orderSearchOptions.printBatch.printOrderIds : []
    }
    return OrderService.getAll(params)
      .then((res) => {
        const { items, totalCount } = res
        commit(_types.mutations.SET_PAGED_ORDERS, items)
        commit(_types.mutations.SET_TOTAL_ORDERS_COUNT, totalCount)
        if (state.currentTab === OrderTab.InStockSoon || state.currentTab === OrderTab.Alerts) {
          commit(_types.mutations.SET_TAB_COUNT, { count: totalCount, tab: state.currentTab })
        }
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.fetchCustomerOrdersPaged] ({ state, commit }, customerID) {
    commit(_types.mutations.SET_LOADING, true)
    const { itemsPerPage, page, orderBy, orderDescending } = state.orderTableOptions
    const params = {
      customerID: customerID,
      skipCount: (page - 1) * itemsPerPage,
      maxResultCount: itemsPerPage,
      orderBy,
      orderDescending,
      getOrdersForAllTenants: true
    }

    return OrderService.getCustomerOrders(params)
      .then((res) => {
        const { items, totalCount } = res
        commit(_types.mutations.SET_PAGED_ORDERS, items)
        commit(_types.mutations.SET_TOTAL_ORDERS_COUNT, totalCount)
      })
      .finally(() => commit(_types.mutations.SET_LOADING, false))
  },
  [_types.actions.fetchOrder] ({ state, commit }, orderNumber) {
    commit(_types.mutations.SET_LOADING_DETAILS, true)
    return OrderService.getByOrderNumber(orderNumber)
      .then((res) => commit(_types.mutations.SET_ORDER, res))
      .finally(() => commit(_types.mutations.SET_LOADING_DETAILS, false))
  },
  [_types.actions.fetchOrderPrints] ({ commit }) {
    return OrderService.getOrderPrints()
      .then((res) => commit(_types.mutations.SET_ORDER_PRINTS, res))
  },
  [_types.actions.changeSearchType] ({ state, commit, dispatch }, searchType) {
    commit(_types.mutations.SET_SEARCH_TYPE, searchType)
  },
  [_types.actions.changeShippingFilters] ({ state, commit, dispatch }, value) {
    commit(_types.mutations.SET_SHIPPING_METHODS, value)
  },
  [_types.actions.changeTenantFilter] ({ commit }, value) {
    commit(_types.mutations.SET_TENANT_FILTER, value)
  },
  [_types.actions.removePrintBatchFilter] ({ commit }) {
    commit(_types.mutations.REMOVE_PRINT_BATCH)
  },
  [_types.actions.changeDates] ({ commit }, newDates) {
    commit(_types.mutations.SET_DATES, newDates)
  },
  [_types.actions.fetchUserAddresses] ({ state, commit }) {
    if (!state.order || !state.order.orderedById) return
    commit(_types.mutations.SET_LOADING_ADDRESSES, true)
    return userService.getUserAddresses(state.order.orderedById)
      .then((res) => commit(_types.mutations.SET_USER_ADDRESSES, res))
      .finally(() => commit(_types.mutations.SET_LOADING_ADDRESSES, false))
  },
  [_types.actions.saveUserAddress] ({ state, commit }, address) {
    if (address.userAddressId) {
      return userService.updateUserAddress(state.order.orderedById, address)
        .then((res) => {
          commit(_types.mutations.SET_USER_ADDRESSES, [...state.userAddresses.filter(x => x.id !== res.id), res])
        })
    } else {
      return userService.createUserAddress(state.order.orderedById, address)
        .then((res) => {
          if (!res) return
          commit(_types.mutations.SET_USER_ADDRESSES, [...state.userAddresses, res])
        })
    }
  },
  [_types.actions.fetchUserPaymentMethods] ({ state, commit }) {
    if (!state.order || !state.order.orderedById) return
    commit(_types.mutations.SET_LOADING_PAYMENT_METHODS, true)
    return userService.getUserPaymentMethods(state.order.orderedById)
      .then((res) => commit(_types.mutations.SET_USER_PAYMENT_METHODS, res))
      .finally(() => commit(_types.mutations.SET_LOADING_PAYMENT_METHODS, false))
  },
  [_types.actions.modifyOrder] ({ state, commit }, intent) {
    commit(intent.commit ? _types.mutations.SET_PROCESSING : _types.mutations.SET_MODIFYING, true)
    return OrderService.createModifyOrderIntent(intent.order, intent.commit)
      .then((res) => {
        if (!res || !res.result) return
        res.result.totalFulfilledToStripe = state.order.totalFulfilledToStripe
        res.result.totalRefundedToStripe = state.order.totalRefundedToStripe
        if (intent.commit) {
          commit(_types.mutations.SET_ORDER, res.result)
        // } else {
        //   let order = res.result
        //   order.setOrder = false
        //   commit(_types.mutations.SET_ORDER, order)
        }
        return res.result
      })
      .finally(() =>
        commit(intent.commit ? _types.mutations.SET_PROCESSING : _types.mutations.SET_MODIFYING, false)
      )
  },
  [_types.actions.modifyShipping] ({ state, commit }, intent) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.createModifyShippingIntent(intent.order, intent.commit)
      .then((res) => {
        if (!res || !res.result) return
        if (intent.commit) {
          commit(_types.mutations.SET_ORDER, res.result)
        }
        return res.result
      })
      .finally(() =>
        commit(_types.mutations.SET_PROCESSING, false)
      )
  },
  [_types.actions.markAsShipped] ({ state, commit }, intent) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.createMarkShippedIntent(intent)
      .then((res) => {
        if (!res) return
        commit(_types.mutations.SET_ORDER, res.order)
        return res.order
      })
      .finally(() =>
        commit(_types.mutations.SET_PROCESSING, false)
      )
  },
  [_types.actions.addOrderNote] ({ commit }, { orderId, orderNumber, newNote }) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.createOrderNote(orderId, orderNumber, newNote)
      .then((res) => commit(_types.mutations.SET_ORDER, res))
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.deleteOrderNote] ({ commit }, { noteId, orderId }) {
    commit(_types.mutations.SET_PROCESSING, true)
    return OrderService.deleteOrderNote(noteId, orderId)
      .then((res) => commit(_types.mutations.SET_ORDER, res))
      .finally(() => commit(_types.mutations.SET_PROCESSING, false))
  },
  [_types.actions.displayZipFileErrors] ({ commit }, param) {
    let errorMsg = null
    let _error = ''
    if (param.hasPackSlipFileErrors || param.hasPickListFileErrors || param.hasPurchaseListFileErrors) {
      _error = param.hasPackSlipFileErrors ? 'pack slips' : ' '
      _error += param.hasPickListFileErrors ? (_error ? ' and ' : '') + ' pick list entries ' : ' '
      _error += param.hasPurchaseListFileErrors ? (_error ? ' and ' : '') + ' purchase list entries ' : ' '
      errorMsg = 'Some ' + _error + ' could not be added. Please review the <b>Errors.txt</b> file for additional information and try again.'
    } else if (param.hasSystemErrors) {
      errorMsg = param.hasSystemErrors ? '<br/>There was an error while preparing the print files. <br/><br/> Please review the Errors.txt file for additional information and try again.' : ''
    }
    if (errorMsg && errorMsg.trim().length > 0) {
      commit(_types.mutations.SET_ORDER_INTENT_RESULT_MESSAGE, errorMsg + '<br/><br/> If the problem persists please send the Errors.txt file to technical support for review')
    }
  }

}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
